import { PracticeAnswer } from 'reducers/practiceAnswers';
import { createActionWithPayload } from './helpers';

export const setPracticeAnswer = (answer: PracticeAnswer) =>
  createActionWithPayload('@practiceAnswer/set', answer);

export type PracticeAnswerActions = ReturnType<typeof setPracticeAnswer>;
